.position__apply-link {
  cursor: pointer;
  max-width: 300px;
  font-size: 26px;
  padding: 5px;
  text-decoration: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 7px;
  color: black;
  transition: color 0.2ms ease-out;

  @media screen and (width <= 991px) {
    font-size: 22px;
  }

  @media screen and (width <= 431px) {
    font-size: 20px;
  }
}

.position__apply-link:hover {
  color: #737373;
}
